<template>
  <v-row
    mt-2
    mb-6
  >
    <v-col cols="12">
      <!-- Button -->
      <v-btn
        :small="$vuetify.breakpoint.xsOnly"
        outlined
        color="primary"
        class="ma-0"
        @click="isVisible = !isVisible"
      >
        Optionally Restrict to a group of funds
      </v-btn>
    </v-col>

    <!-- Fund Group Manager -->
    <v-col
      v-if="isVisible"
      cols="12"
      mt-4
    >
      <v-card>
        <v-card-text>
          <slot />
          <core-fund-group-manager
            :filer-group.sync="filerGroupProxy"
            flat
            no-padding
            optional
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    filerGroup: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isVisible: false,
      filerGroupProxy: {}
    }
  },

  watch: {
    filerGroupProxy (group) {
      this.$emit('update:filerGroup', group)
    }
  },

  created () {
    this.filerGroupProxy = this.filerGroup
  }
}
</script>
